<script>
import api from "@services/api";
import TabelaUsuarioItem from "@components/Tables/TabelaUsuarioItem";
import Treeselect from "@riophae/vue-treeselect";
import "@riophae/vue-treeselect/dist/vue-treeselect.css";

export default {
  props: {
    selecionado: {
      type: String,
      default: ""
    }
  },
  data() {
    return {
      listaCombo: [],
      selected: null,
      tipoid: "",
      lista: null,
      fields: [
        { name: "denominacao", description: "" },
        { name: "relatorio", description: "" }
      ],
      tipoConsulta: "",
      showModalAdd: false,
      listaUsuario: [],
      selectedUsuario: null,
      grupoItemNome: ""
    };
  },
  components: {
    TabelaUsuarioItem,
    Treeselect
  },
  methods: {
    GetListaCombo() {
      api
        .get("crud/Grupo/SelectGrupoUsuariosItens", {
          params: {
            grupoId: this.$route.params.id
          }
        })
        .then(response => {
          this.listaCombo = response.data["data"];
          var listaTempo = this.listaCombo.filter(x => x.tipo !== "USUÁRIO");
          this.grupoItemNome = listaTempo[0].tipo;
        });
    },
    verificarTipoConsulta() {
      this.tipoid = this.selected.split("-");
      if (this.tipoid[0] !== "USUÁRIO") {
        this.getGrupoItem(this.tipoid[1]);
        this.tipoConsulta = "Usuários com Permissão";
        this.getListaUsuarios(this.tipoid[1]);
        this.selectedUsuario = null;
      } else if (this.tipoid[0] === "USUÁRIO") {
        this.getGrupoItemPorUsuario(this.tipoid[1]);
        this.tipoConsulta = "Permissões do Usuário";
      }
    },
    getGrupoItemPorUsuario(userId) {
      api
        .get(`crud/Grupo/SelectGrupoItemPorUsuario`, {
          params: { usuarioId: userId, grupoId: this.$route.params.id }
        })
        .then(response => (this.lista = response.data["data"]));

      this.fields = [
        { name: "denominacao", description: this.grupoItemNome },
        { name: "codigo", description: "Código" }
      ];
    },
    getGrupoItem(grupoitemId) {
      api
        .get(`crud/Grupo/SelectGrupoItens`, {
          params: { grupoItemId: grupoitemId }
        })
        .then(response => (this.lista = response.data["data"]));

      this.fields = [
        { name: "nome", description: "Usuário" },
        { name: "email", description: "Email" }
      ];
    },
    getListaUsuarios(grupoitemId) {
      api
        .get(`crud/Grupo/SelectUsuariosNotGrupoItem`, {
          params: { grupoItemId: grupoitemId }
        })
        .then(response => {
          this.listaUsuario = response.data["data"];
          this.listaUsuario = this.listaUsuario.map(c => ({
            label: c.denominacao,
            id: c.id
          }));
        });
    },
    facharModal() {
      this.showModalAdd = false;
    },
    adicionarVinculoGrupoItemUsuario() {
      this.showModalAdd = false;
      var grupoItem;
      var usuarioId;

      grupoItem = this.tipoid[1];
      usuarioId = this.selectedUsuario;

      this.addGrupoItemUsuario(grupoItem, usuarioId);
    },
    resetModal() {},
    deletar(grupoItemUsuarioId) {
      api
        .delete(`crud/grupo/deletarGrupoItemUsuario`, {
          params: { grupoItemUsuarioId: grupoItemUsuarioId }
        })
        .then(response => {
          if (response.data["status"].toLowerCase() == "success") {
            this.verificarTipoConsulta();
          }
        });
    },
    addGrupoItemUsuario(grupoItemId, usuarioId) {
      let formData = new FormData();
      formData.append("usuarioId", usuarioId);
      formData.append("grupoItemId", grupoItemId);

      api
        .post(`crud/grupo/adicionarGrupoItemUsuario`, formData)
        .then(response => {
          if (response.data["status"].toLowerCase() == "success") {
            this.verificarTipoConsulta();
          }
        });
    }
  },
  computed: {
    listaRetorno() {
      return this.lista;
    },
    listaComboComp() {
      return this.lodash
        .chain(this.listaCombo)
        .groupBy("tipo")
        .map((value, key) => ({
          id: key,
          label: key,
          children: value.map(a => ({
            label: a.denominacao,
            id: a.tipo + "-" + a.id
          }))
        }))
        .value();
    }
  },
  created() {
    this.GetListaCombo();
  },
  watch: {
    selected: function() {
      if (this.selected != null) {
        this.verificarTipoConsulta();
      }
    }
  }
};
</script>

<template>
  <div>
    <div class="row">
      <b-form-group class="col-md-4 mb-3 ml-1">
        <treeselect
          :options="listaComboComp"
          :multiple="false"
          :flatten-search-results="true"
          :disable-branch-nodes="true"
          :show-count="true"
          :clearable="false"
          :searchable="true"
          placeholder="Usuarios/workspace"
          v-model="selected"
        />
      </b-form-group>

      <div class="button-list text-right">
        <b-button
          class="btn btn-sm btn-icon"
          v-if="this.tipoid[0] !== 'USUÁRIO'"
          variant="primary"
          v-on:click="showModalAdd = true"
        >
          Nova Permissão
        </b-button>
      </div>
      <b-form-group class="col-md-3 mb-3 ml-1">
        <h4 for="">{{ this.tipoConsulta }}</h4>
      </b-form-group>
    </div>
    <div class="row">
      <TabelaUsuarioItem
        class="col-md-12 mb-3 ml-1"
        :lista="this.listaRetorno"
        :fields="this.fields"
        :tipo="this.tipoid[0]"
        @delete-table="deletar"
        @add-table="addGrupoItemUsuario"
        @update-table="verificarTipoConsulta"
      ></TabelaUsuarioItem>
    </div>
    <b-modal
      v-model="showModalAdd"
      title="Nova Permissão"
      centered
      hide-footer
      @close="resetModal"
      @change="resetModal"
      @hidden="facharModal()"
    >
      <b-form-group
        id="input-group-1"
        label="Usuários"
        label-for="select"
        class="col-md-12 text-left"
      >
        <treeselect
          :options="listaUsuario"
          :multiple="false"
          :show-count="true"
          :clearable="false"
          :searchable="true"
          placeholder="Usuários"
          v-model="selectedUsuario"
        />
      </b-form-group>
      <div class="button-list text-right">
        <b-button
          class="btn btn btn-icon"
          variant="light"
          @click="showModalAdd = false"
          >Cancelar</b-button
        >
        <b-button
          class="btn btn btn-icon"
          variant="primary"
          v-on:click="adicionarVinculoGrupoItemUsuario()"
          >Adicionar</b-button
        >
      </div>
    </b-modal>
  </div>
</template>
